import React, {Component} from 'react';
import {Row, Col, Form, FormGroup, ControlLabel} from "react-bootstrap";
import {TopButtonAction} from "../../../../componentsTopsa/buttons/TopButtons";
import Dropzone from "react-dropzone";
import LogowanieService from "../../../logowanie/LogowanieService";
import {TopAlertInformacja} from "../../../../componentsTopsa/alerty/TopAlerts";
import {TopSelect} from "../../../../componentsTopsa/selects/TopSelects";
import EBOK_templates from "../../../../utilities/templates/EBOK_templates";

export default class EBOKWatekFormularzOdpowiedzi extends Component {
    constructor(props) {
        super(props);
        this.state = {
            plikInvalid: false,
            plik: null,
            plikBase: null,
            odpowiedz: '',
            szablonebok: null
        };
        this.onDrop = this.onDrop.bind(this)
        this.getBase64 = this.getBase64.bind(this)
        this.onChangeodp = this.onChangeodp.bind(this)
        this.onClickZapisz = this.onClickZapisz.bind(this)
        this.onChangeSzablonEBOK = this.onChangeSzablonEBOK.bind(this)
    }

    componentDidMount() {
    }

    onDrop(accepted, rejected) {
        if (rejected.length !== 0) {
            this.setState({plikInvalid: true, plik: []})
        } else {
            this.getBase64(accepted)
            this.setState({plikInvalid: false, plik: accepted})
        }
    }

    getBase64(file) {
        let reader = new FileReader();
        reader.readAsDataURL(file[0]);
        reader.onload = () => {
            this.setState({plikBase: reader.result.substr(reader.result.indexOf(',') + 1)})
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
    }

    onChangeodp(e) {
        if (e.target.value.length > 1000) {
            document.getElementById('odpowiedztextarea').value = this.state.odpowiedz
        }
        else {
            this.setState({
                odpowiedz: e.target.value
            })
        }

    }

    onClickZapisz() {

        if(this.state.odpowiedz.length>1000){
            alert('Podana wiadomość przekroczyła dozwoloną liczbę znaków (1000)!')
        }
        else if (this.state.odpowiedz.length > 0) {
            let obj;

            if (Boolean(this.state.plik)) {
                if (this.state.plik[0].size <= 10485760) {
                    obj = {
                        "plik": (!this.state.plikInvalid) ? this.state.plikBase : null,
                        "plikNazwa": (!this.state.plikInvalid) ? this.state.plik[0].name : null,
                        "plikRozmiar": (!this.state.plikInvalid) ? this.state.plik[0].size : null,
                        "plikTyp": (!this.state.plikInvalid) ? this.state.plik[0].type : null,
                        "tresc": this.state.odpowiedz,
                        "wpisalId": LogowanieService.pobierzZalogowanego().idUz
                    }

                    this.props.handleSendResponse(obj)
                    this.setState({
                        plikInvalid: false,
                        plik: null,
                        plikBase: null,
                        odpowiedz: '',
                    })
                    document.getElementById('odpowiedztextarea').value = ''

                } else alert('Plik nie może być większy niż 10 MB!')
            }
            else {
                obj = {
                    "plik": null,
                    "plikNazwa": null,
                    "plikRozmiar": null,
                    "plikTyp": null,
                    "tresc": this.state.odpowiedz,
                    "wpisalId": LogowanieService.pobierzZalogowanego().idUz
                }
                this.props.handleSendResponse(obj)
                this.setState({
                    plikInvalid: false,
                    plik: null,
                    plikBase: null,
                    odpowiedz: '',
                })
                document.getElementById('odpowiedztextarea').value = ''
            }
        }
        else {
            alert('Nie można wysłać pustej odpowiedzi!')
        }
    }

    renderSzablonEBOK(option) {
        return <div>
            <div>
            {option.label}
            </div>
            <div style={{color:"grey",fontSize:"10px", fontStyle:"italic"}}>
            {option.tresc}
            </div>
        </div>
    }

    onChangeSzablonEBOK(e) {
        this.setState({
            szablonebok: e
        })
        if (e !== null) {
            this.setState({
                odpowiedz: e.tresc
            })
            document.getElementById('odpowiedztextarea').value = e.tresc
        } else {
            if (window.confirm("Czy na pewno skasować szablon? Spowoduje to wyczyszczenie pola tekstowego odpowiedzi")) {
                this.setState({
                    odpowiedz: ""
                })
                document.getElementById('odpowiedztextarea').value = ''
            }
        }
    }

    render() {

        return (
            <Row>
                <Col xs={12} style={{marginTop: '15px'}}>
                    <div className={'thumbnail'} style={{border: '1px solid #888', padding: '0 15px 15px 15px'}}>
                        <Row>
                            <Form>
                                <FormGroup>
                                    <Col xs={12}>
                                        <ControlLabel>
                                            Dodaj odpowiedź do tego wątku <span style={{
                                            fontSize: '12px',
                                            color: 'grey',
                                            fontStyle: 'italic',
                                            fontWeight: 'normal'
                                        }}>{this.state.odpowiedz.length}/1000 znaków</span>
                                            <span style={{fontWeight: 'normal'}}>
                                                    <TopAlertInformacja inline={true}
                                                                        text={Boolean(this.props.czyJednorazowy) ?
                                                                            'Zgłoszenie wysłane przez klienta anonimowego - odpowiedź zostanie wysłana tylko na adres email.'
                                                                            :
                                                                            'Odpowiedź zostanie wysłana również na adres email.'
                                                                        }/>
                                                    </span>
                                        </ControlLabel>
                                    </Col>
                                    <Col xs={12}>
                                                <textarea className={'form-control'} style={{maxWidth: '100%'}}
                                                          placeholder={'Odpowiedź...'} id={'odpowiedztextarea'}
                                                          rows={(Boolean(this.state.szablonebok))? 8 : 4}
                                                          onChange={this.onChangeodp}></textarea>
                                    </Col>
                                    <Col xs={8}>
                                        {
                                            Boolean(this.state.plik) ?
                                                <h5 style={{color: 'grey', fontStyle: 'italic'}}>
                                                    Wybrano plik: {this.state.plik[0].name}. Aby usunąć, kliknij
                                                    <i className={'fa fa-trash'}
                                                       style={{color: 'firebrick', cursor: 'pointer', marginLeft: '5px'}}
                                                       onClick={() => {
                                                           this.setState({
                                                               plik: null,
                                                               plikBase: null
                                                           })
                                                       }}></i>
                                                </h5>
                                                :
                                                <Dropzone onDrop={this.onDrop} style={{}} multiple={false}>
                                                    <div style={{
                                                        border: '1px dashed #ccc', marginTop: '5px', display: 'inline-block',
                                                        padding: '5px 10px', fontSize: '14px', color: 'grey', fontStyle: 'italic',
                                                        cursor: 'pointer'
                                                    }}>
                                                        <span><i className={'fa fa-paperclip'}></i> Przeciagnij i upuść bądź kliknij aby wybrać plik (max 10MB)</span>
                                                    </div>
                                                </Dropzone>
                                        }
                                    </Col>
                                    <Col xs={4}>
                                        <div className={'pull-right'} style={{marginTop: '5px'}}>
                                            <TopButtonAction onClick={this.onClickZapisz} text={'Wyślij odpowiedź'} iconType={'fa fa-send'}
                                                             btnColor={'primary'} btnSize={'md'}/>
                                        </div>
                                    </Col>
                                </FormGroup>
                                <FormGroup>
                                    <Col xs={12}>
                                    </Col>
                                </FormGroup>
                            </Form>
                        </Row>
                    </div>
                </Col>
                <Col xs={12}>
                    <h4>Szablony odpowiedzi</h4>
                    <Row>
                        <Col xs={6}>
                            <ControlLabel>Wybierz z listy szablon aby skopiować:</ControlLabel>
                            <TopSelect onChange={this.onChangeSzablonEBOK} value={this.state.szablonebok} options={EBOK_templates.SZABLONY_EBOK}
                                       valueRenderer={this.renderSzablonEBOK} optionRenderer={this.renderSzablonEBOK} placeholder={"Wybierz szablon..."}

                            />
                        </Col>
                    </Row>

                </Col>
            </Row>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/klienciConfig/eBOK/componentsWatek/EBOKWatekFormularzOdpowiedzi.js